var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5821 8.34699C21.3521 7.42316 20.6744 6.69559 19.8139 6.44867C18.2542 6 12 6 12 6C12 6 5.74586 6 4.18613 6.44867C3.32565 6.69563 2.64794 7.42316 2.41792 8.34699C2 10.0215 2 13.5152 2 13.5152C2 13.5152 2 17.0088 2.41792 18.6833C2.64794 19.6071 3.32565 20.3044 4.18613 20.5513C5.74586 21 12 21 12 21C12 21 18.2541 21 19.8139 20.5513C20.6744 20.3044 21.3521 19.6071 21.5821 18.6833C22 17.0088 22 13.5152 22 13.5152C22 13.5152 22 10.0215 21.5821 8.34699ZM9.95453 16.6871V10.3432L15.1818 13.5152L9.95453 16.6871Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.df4e4d3e3f37d0c051d7506287d51c96.svg";
export { ForwardRef as ReactComponent };